<template lang="pug">
div
  modal.active(
    :active='showModal'
    @close='$router.back()',
    title='Cancelar publicação'
  )
    div(slot='modal-body')
      h5 Tem certeza?
      p Se confirmar a publicação vai ser cancelada, os documentos vinculados serão desvinculados e voltam para agurdando ciência.
      p.text-error Depois que confirmar não poderá ser desfeito.
    .columns.align-center(slot='modal-footer')
      .column
      .column-col-auto
        button.btn.btn-primary(
          :class='{ loading }'
          @click='onConfirm'
        )
          btn-content(name='confirm' label="Cancelar")
</template>

<script>
import toastErrors from '@/lib/errors/toastErrors'

export default {
  vuex: {
    'fiscalizacao/docPublicacoes': {
      state: ['current', 'loading', 'status'],
      actions: ['fetchCancelar'],
    },
  },
  data() {
    return {
      showModal: true,
    }
  },
  methods: {
    async onConfirm() {
      try {
        await this.fetchCancelar(this.current.id)
        this.$toaster.success('Cancelado com sucesso')
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      }
    },
  },
}
</script>
